import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import { browserHistory }   from 'react-router';

let HttpService = require('../Managers/HttpService');

class BeginReferencing extends Component {
    componentWillMount() {
        // if we dont have a hash, send to error page
        if ( ! this.props.params.hash) {
            browserHistory.push('/error/no-auth');
            return false;
        } else {
            // Clear localStorage, preventing 'ghosting' of data from previous cases
            // entered by the same agent user.
            window.localStorage.clear();

            HttpService.setAgentHash(this.props.params.hash);

            browserHistory.push('/case/begin');
            return false;
        }
    }

    render() {
        return(
            <div className="loading">
                <div className="spinner">
                    <p><strong>Loading, please wait</strong></p>
                    <div className="bounce1" />
                    <div className="bounce2" />
                    <div className="bounce3" />
                </div>
            </div>
        );
    }
}

BeginReferencing.propTypes = {
    params: PropTypes.object,
};

export default BeginReferencing;


// WEBPACK FOOTER //
// ./src/components/Screens/BeginReferencing.js